import { useAuth } from '../hooks/useAuth'
import { Splash } from '../../pages/Splash'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isLoading, user, error } = useAuth()

  if (isLoading) {
    return <Splash />
  }

  if (error || !user) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-red-50 dark:bg-gray-950 px-4">
        <div className="text-center max-w-sm">
          <h1 className="text-2xl font-bold text-red-900 dark:text-red-300 mb-2">Ошибка авторизации</h1>
          <p className="text-red-800 dark:text-red-200/95 mb-4">{error || 'Не удалось войти'}</p>
          <p className="text-sm text-red-700 dark:text-gray-300">Откройте приложение в боте MAX</p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
